document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.js-header-scroll');
  let lastScrollTop = 0;
  let ticking = false;
  const SCROLL_THRESHOLD = 180; // Adjust this value to change when the header hides
  const MOBILE_BREAKPOINT = 768; // Adjust this value to match your mobile breakpoint

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function handleScroll() {
    if (!isMobile()) {
      header.classList.remove('header--hidden');
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > SCROLL_THRESHOLD) {
      if (scrollTop > lastScrollTop) {
        // Scrolling down
        header.classList.add('header--hidden');
      } else {
        // Scrolling up
        header.classList.remove('header--hidden');
      }
    } else {
      // At the top of the page
      header.classList.remove('header--hidden');
    }

    lastScrollTop = scrollTop;
    ticking = false;
  }

  function handleResize() {
    if (!isMobile()) {
      header.classList.remove('header--hidden');
    }
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  window.addEventListener('resize', handleResize);
  handleResize(); // Initial check
});